<template>
    <div class="card mt-3" style="margin-bottom:10px">
        <div class=" card-body">

            <h6 style="background: #0078be!important;" class="tituloMovil card-title bg-primary text-white w-100 p-1">
                REASIGNACIÓN DE TURNOS
            </h6>
            <div class="row">

                <DataTable :key="tablaKey" :columns="columns" :options="options" :data="transactions" class="table tablesorter"
                    width="100%">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th data-priority="1">Fecha/Hora</th>
                            <th>idSolicitud</th>
                            <th data-priority="2">Paciente</th>
                            <th>Registrado por</th>
                            <th data-priority="3">Especialidad</th>
                            <th data-priority="4">Doctor</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                </DataTable>

            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
import DataTable from 'datatables.net-vue3'
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-responsive';
import $ from "jquery";
import { filtrarEspecialidades } from '@/config/especialidades';

export default {
    name: "Reasignacion de pacientes",
    components: {
        DataTable
    },

    data() {
        return {
            loading: true,
            cargandoPantalla: false,
            tablaKey: 0,
            isMobile: this.$isMobile,
            tokenAuth: localStorage.getItem("tokenAuth"),
            transactions: [],
            especialidades: [],
            doctores: [],
            columns: [
                { data: null, render: (data, type, row, meta) => meta.row + 1 },
                { data: 'date_at' },
                { data: 'codigo_consulta' },
                { data: 'nombres_pacientes' },
                { data: 'registra' },
                {
                    data: null,
                    render: (data, type, row, meta) => {
                        return (`
                            <select class="form-select form-select-sm" onchange="handleEspecialidadChange(this, '${row.codigo_consulta}', '${row.nombres_pacientes}')">
                                <option value="">Seleccione especialidad</option>
                                ${this.especialidades.map(esp => `
                                    <option value="${esp.codigo}" data-nombre="${esp.especialidad_nombre}" ${data.name_especialidad === esp.especialidad_nombre ? 'selected' : ''}>
                                        ${esp.especialidad_nombre}
                                    </option>
                                `).join('')}
                            </select>
                        `);
                    }
                },
                {
                    data: null,
                    render: (data, type, row, meta) => {
                        // Obtener los doctores de la especialidad seleccionada
                        const especialidadSeleccionada = this.especialidades.find(esp =>
                            esp.especialidad_nombre === data.name_especialidad
                        );
                        const doctoresEspecialidad = especialidadSeleccionada ? especialidadSeleccionada.doctores : [];

                        return (`
                            <select class="form-select form-select-sm" id="doctor-${row.codigo_consulta}">
                                <option value="">Seleccione doctor</option>
                                ${doctoresEspecialidad.map(doc => `
                                    <option value="${doc.cedula}" 
                                        data-doctor-id="${doc.doctor_Id}"
                                        data-doctor-nombre="${doc.doctor_nombre}"
                                        ${data.doctor === doc.doctor_nombre ? 'selected' : ''}>
                                        ${doc.doctor_nombre}
                                    </option>
                                `).join('')}
                            </select>
                        `);
                    }
                },
                {
                    data: null,
                    render: (data, type, row, meta) => {
                        const isAdmin = this.userRole === 'administrador' || this.userRole === 'enfermera';
                        return (`
                            <div class="d-flex justify-content-center align-items-center gap-2">
                                <button class="btn btn-primary btn-sm" onclick="handleGuardarCambios('${row.codigo_consulta}', '${data.doctor_Id}', '${data.name_especialidad}', '${data.doctor}', '${row.nombres_pacientes}')" title="Guardar cambios">
                                    <i class="fas fa-save"></i>
                                </button>
                                <button class="btn btn-danger btn-sm" onclick="handleMarcarAusente('${row.codigo_consulta}', '${row.nombres_pacientes}')" title="Marcar como ausente">
                                    <i class="fas fa-user-times"></i>
                                </button>
                                ${isAdmin ? `
                                    <button class="btn btn-sm btn-delete" onclick="handleEliminar('${row.codigo_consulta}', '${row.nombres_pacientes}')">
                                        <i class="dataAtencion fas fa-trash me-2"></i>
                                    </button>
                                ` : ''}
                            </div>
                        `);
                    }
                }
            ],
            options: {
                responsive: true,
                "ordering": false,
                columnDefs: [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: -1 },
                    { width: '80px', targets: 1 }, //asi cambiamos el tamaño de las columnas y el numero es el de la columna
                    { width: '80px', targets: 2 },
                    { width: '80px', targets: 4 },
                    { width: '140px', targets: 5 },
                    { width: '170px', targets: 6 },
                    { width: '170px', targets: 7 },
                    { className: 'text-center', targets: 2 }
                ],
                lengthMenu: [
                    [7, 15, 25, 35, 50, -1],
                    [7, 15, 25, 35, 50, "All"],
                ],
                pageLength: 15,
                "language": {
                    "search": "Buscar:",
                    "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "searchPlaceholder": "Ingrese algún dato",
                    "zeroRecords": "Lo sentimos, no se encontraron resultados",
                    "processing": "Buscando. Espere por favor...",
                    "sLengthMenu": "Mostrar _MENU_ registros",
                    "oPaginate": {
                        "sFirst": "Primero",
                        "sLast": "Último",
                        "sNext": "Siguiente",
                        "sPrevious": "Anterior"
                    },

                }
            },
        };
    },
    computed: {
        userRole() {
            const encryptedRole = localStorage.getItem("aut");
            if (encryptedRole && this.$encryptBackoffice && this.$encryptBackoffice.decrypt) {
                return this.$encryptBackoffice.decrypt(encryptedRole);
            }
            return null;
        }
    },
    watch: {},

    activated() {
        this.cargarPantalla();
    },
    mounted() {
        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        this.cargarPantalla();

        // Agregar las funciones globales para el manejo de cambios
        window.handleEspecialidadChange = (selectElement, codigoConsulta, nombrePaciente) => {
            const nuevaEspecialidad = selectElement.value;
            if (nuevaEspecialidad) {
                // Obtener los doctores de la nueva especialidad
                const especialidadSeleccionada = this.especialidades.find(esp =>
                    esp.codigo === nuevaEspecialidad
                );

                if (especialidadSeleccionada) {
                    const doctorSelect = document.getElementById(`doctor-${codigoConsulta}`);
                    if (doctorSelect) {
                        doctorSelect.innerHTML = `
                            <option value="">Seleccione doctor</option>
                            ${(especialidadSeleccionada.doctores || []).map(doc => `
                                <option value="${doc.cedula}"
                                    data-doctor-id="${doc.doctor_Id || ''}"
                                    data-doctor-nombre="${doc.doctor_nombre}">
                                    ${doc.doctor_nombre}
                                </option>
                            `).join('')}
                        `;
                    }
                }
            }
        };

        window.handleGuardarCambios = (codigoConsulta, doctorId, especialidad, doctor, nombrePaciente) => {
            this.$swal.fire({
                title: "Confirmar cambios",
                html: `
                    <div class="text-start">
                        <p><strong>ID Solicitud:</strong> ${codigoConsulta}</p>
                        <p><strong>Paciente:</strong> ${nombrePaciente}</p>
                        <p><strong>Especialidad:</strong> ${especialidad}</p>
                        <p><strong>Doctor:</strong> ${doctor}</p>
                    </div>
                `,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-danger"
                },
                buttonsStyling: false
            }).then((result) => {
                if (result.isConfirmed) {
                    const doctorSelect = document.getElementById(`doctor-${codigoConsulta}`);
                    const especialidadSelect = document.querySelector(`select[onchange*="${codigoConsulta}"]`);
                    if (doctorSelect && doctorSelect.value && especialidadSelect && especialidadSelect.value) {
                        const selectedDoctorOption = doctorSelect.options[doctorSelect.selectedIndex];
                        const doctorIdSeleccionado = selectedDoctorOption.getAttribute('data-doctor-id');
                        this.cambiarDoctor(codigoConsulta, doctorSelect.value, especialidadSelect.value, doctorIdSeleccionado);
                    }
                }
            });
        };

        window.handleMarcarAusente = (codigoConsulta, nombrePaciente) => {
            this.$swal.fire({
                title: "¿Marcar como ausente?",
                html: `
                    <div class="text-start">
                        <p><strong>ID Solicitud:</strong> ${codigoConsulta}</p>
                        <p><strong>Paciente:</strong> ${nombrePaciente}</p>
                    </div>
                `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, marcar ausente",
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: "btn btn-secondary"
                },
                buttonsStyling: false
            }).then((result) => {
                if (result.isConfirmed) {
                    this.marcarAusente(codigoConsulta);
                }
            });
        };

        window.handleEliminar = (codigoConsulta, nombrePaciente) => {
            this.$swal.fire({
                title: "¿Estás seguro?",
                html: `
                    <div class="text-start">
                        <p><strong>ID Solicitud:</strong> ${codigoConsulta}</p>
                        <p><strong>Paciente:</strong> ${nombrePaciente}</p>
                    </div>
                `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: "btn btn-secondary"
                },
                buttonsStyling: false
            }).then((result) => {
                if (result.isConfirmed) {
                    this.eliminarTurno(codigoConsulta);
                }
            });
        };

                    



    },
    methods: {
        eliminarTurno(codigoConsulta) {

            this.$https.post('/listar/getDeleteTurno', { codigo: codigoConsulta }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                if (response.data.code === 200) {
                    this.showSuccessToast('Turno eliminado correctamente')
                    this.loadData()
                }
            })


        },
        async cargarPantalla() {
            if (this.cargandoPantalla) return;
            this.cargandoPantalla = true;
            this.loading = true;
            this.showLoading2('Cargando especialidades y doctores...');

            try {
                await this.loadEspecialidadesDoctores();
                await this.loadData();
            } finally {
                this.loading = false;
                this.cargandoPantalla = false;
                this.hideLoading();
            }
        },

        async loadData() {
            try {
                const response = await this.$https.post('/pacientes/getLoadTicketAdministracionEnfermera', {}, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": this.tokenAuth,
                    }
                });

                this.transactions = response.data.code === 200 ? (response.data.datos || []) : [];
            } catch (error) {
                this.transactions = [];
                this.$toast.error("Error al cargar los turnos", {
                    position: "top-right",
                    max: 10
                });
            }

            this.tablaKey += 1;
        },

        async loadEspecialidadesDoctores() {
            try {
                const response = await this.$https.post('/especialidades/getLoadEspecialidadDoctoresAll', {}, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": this.tokenAuth,
                    }
                });

                this.especialidades = response.data.code === 200
                    ? filtrarEspecialidades(response.data.datos || [])
                    : [];
            } catch (error) {
                this.especialidades = [];
                this.$toast.error("Error al cargar especialidades", {
                    position: "top-right",
                    max: 10
                });
            }
        },

        async cambiarEspecialidad(codigoConsulta, nuevaEspecialidad) {
            try {


                console.log(codigoConsulta, nuevaEspecialidad)


            } catch (error) {
                this.$swal.fire({
                    title: "Error",
                    text: error.message || "Error al actualizar la especialidad",
                    icon: "error",
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    buttonsStyling: false,
                });
            }
        },

        //Aqui envio a reasignar los turnos, es decir a actualizar el doctor de un turno
        async cambiarDoctor(codigoConsulta, nuevoDoctor, nuevaEspecialidad, doctorId) {

            this.showLoading()
            try {

                console.log('Datos para reasignar:', {
                    turno_id: codigoConsulta,
                    name_especialidad: nuevaEspecialidad,
                    doctor_dni: nuevoDoctor
                });

                const response = await this.$https.post('/listar/getReasignarTurnos', {
                    turno_id: codigoConsulta,
                    name_especialidad: nuevaEspecialidad,
                    doctor_dni: nuevoDoctor
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": this.tokenAuth,
                    }
                });

                if (response.data.code === 200) {
                    this.$swal.fire({
                        title: "Éxito",
                        text: "Turno reasignado correctamente",
                        icon: "success",
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                        buttonsStyling: false,
                        timer: 1500
                    });
                    this.loadData(); // Recargar datos
                }

            } catch (error) {
                if (error.response.status === 400) {
                    this.showErrorMejor(error.response.data.message)
                }
                if (error.response.status === 401) {
                    this.showSessionExpiredAlert()
                }
            }
        },

        async marcarAusente(codigoConsulta) {
            this.showLoading()
            try {

                console.log('Marcar Ausente')
                console.log(codigoConsulta)

                const response = await this.$https.post("/consulta/getUpdatePacientesAusentes", { codigo: codigoConsulta }, { headers: { Authorization: this.tokenAuth } });

                if (response.data.code === 200) {
                    const datos = response.data.message;
                    this.loadData();
                    this.showOk(datos)
                }

            } catch (error) {
                if (error.response.status === 400) {
                    this.showErrorMejor(error.response.data.message)
                }
                if (error.response.status === 401) {
                    this.showSessionExpiredAlert()
                }
            }
        }
    }
}
</script>


<style lang="scss">
@import "datatables.net-dt";
@import 'datatables.net-responsive-dt';
</style>